import { render, staticRenderFns } from "./ServerList.vue?vue&type=template&id=f160639a&scoped=true"
import script from "./ServerList.vue?vue&type=script&lang=js"
export * from "./ServerList.vue?vue&type=script&lang=js"
import style0 from "./ServerList.vue?vue&type=style&index=0&id=f160639a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f160639a",
  null
  
)

export default component.exports